import _process from "process";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};
var process = _process;

/*!
 * is-windows <https://github.com/jonschlinkert/is-windows>
 *
 * Copyright © 2015-2018, Jon Schlinkert.
 * Released under the MIT License.
 */
(function (factory) {
  if (exports && true && true) {
    exports = factory();
  } else if (typeof window !== "undefined") {
    window.isWindows = factory();
  } else if (typeof _global !== "undefined") {
    _global.isWindows = factory();
  } else if (typeof self !== "undefined") {
    self.isWindows = factory();
  } else {
    (this || _global).isWindows = factory();
  }
})(function () {
  'use strict';

  return function isWindows() {
    return process && (process.platform === "win32" || /^(msys|cygwin)$/.test(process.env.OSTYPE));
  };
});

export default exports;